import React, { memo } from 'react';
import { Box, MenuItem, BoxProps } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { SelectFilter, AlyceTheme } from '@alycecom/ui';

import useResponsive from '../../../../hooks/useResponsive';
import { COUNTRY_FILTER } from '../../constants/filters.constants';
import { TCountry } from '../../../../store/countries/countries.types';

const useStyles = makeStyles<AlyceTheme>(({ spacing, palette }) => ({
  tooltipLink: {
    cursor: 'pointer',
    color: palette.link.main,
    textDecoration: 'none',
  },
  countryImage: {
    marginRight: spacing(1),
    width: 18,
    height: 18,
  },
  countrySelect: {
    width: 200,
    marginRight: spacing(1),
  },
  countrySelectMobile: {
    width: '100%',
  },
}));

export interface ICountriesFilterProps extends Omit<BoxProps, 'onChange'> {
  countryId: number;
  countries: TCountry[];
  onChange: (arg0: TCountry) => void;
}

const CountriesFilter = ({ countryId, countries, onChange, ...WrapperProps }: ICountriesFilterProps): JSX.Element => {
  const { isMobile } = useResponsive();
  const classes = useStyles();
  return (
    <Box {...WrapperProps}>
      <SelectFilter
        name={COUNTRY_FILTER.key}
        label={COUNTRY_FILTER.label}
        classes={{ root: isMobile ? classes.countrySelectMobile : classes.countrySelect }}
        value={countryId || ''}
        renderItems={() =>
          countries.map(country => (
            <MenuItem key={country.name} value={country.id} onClick={() => onChange(country)}>
              <Box display="flex" alignItems="center" color="text.primary">
                <img
                  className={classes.countryImage}
                  width={21}
                  height={13}
                  src={country.image}
                  alt={`${country.name} flag`}
                />
                <Box className="select-textAlign-ie">{country.name}</Box>
              </Box>
            </MenuItem>
          ))
        }
      />
    </Box>
  );
};

export default memo(CountriesFilter);
